import StatusHandler from 'app/shared-components/StatusHandler'

import useGetRegionalGroupById from '../hooks/useGetRegionalGroupById'
import RegionalGroupForm from '../RegionalGroupForm'

const Overview = ({
    id,
}: { id: number }) => {
    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
    } = useGetRegionalGroupById(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <RegionalGroupForm
                disabled
                data={data}
            />
        </StatusHandler>
    )
}

export default Overview
